export function truncateToDecimalPlaces(value, decimals) {
    // Ensure the value is a number and decimals is a valid integer
    if (isNaN(value) || isNaN(decimals) || decimals < 0) {
        return value;  // Return the value if the input is invalid
    }

    // Multiply by 10^decimals to shift the decimal point
    const multiplier = Math.pow(10, decimals);

    // Truncate the value and shift the decimal point back
    return (Math.floor(value * multiplier) / multiplier).toFixed(decimals);
}
